import { render, staticRenderFns } from "./MarketingCampaignTemplate.vue?vue&type=template&id=6fad667c&scoped=true"
import script from "./MarketingCampaignTemplate.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignTemplate.vue?vue&type=script&lang=js"
import style0 from "./MarketingCampaignTemplate.vue?vue&type=style&index=0&id=6fad667c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad667c",
  null
  
)

export default component.exports